// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1qybu","label":"Radio_label__1Pztu","checkMark":"Radio_checkMark__1XsCO","disabled":"Radio_disabled__3KUEq"};